export interface InteractiveSessionState {
    code: string;
    participants_count: number;
    participants: string[];
    current_question?: {
        type: 'word_cloud' | 'mcq' | 'short_answer';
        data: any;
        timestamp: string;
    };
    responses: Array<{
        user: string;
        answer: any;
        timestamp: string;
    }>;
}

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api';
// Determine WS URL based on API URL (replace http with ws, https with wss)
const WS_BASE_URL = API_BASE_URL.replace(/^http/, 'ws').replace(/^https/, 'wss');

export const InteractiveService = {
    // HTTP Methods
    async createSession(hostId: string = 'teacher'): Promise<string> {
        const res = await fetch(`${API_BASE_URL}/active/create`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ host_id: hostId })
        });
        if (!res.ok) throw new Error('Failed to create session');
        const data = await res.json();
        return data.code;
    },

    // Đọc .docx phía server (công thức MathType/OMML→LaTeX, tách ảnh) → câu hỏi cho phiên trực tiếp
    async parseDocx(file: File): Promise<{ questions: any[]; count: number }> {
        const fd = new FormData();
        fd.append('file', file);
        const res = await fetch(`${API_BASE_URL}/active/parse-docx`, { method: 'POST', body: fd });
        if (!res.ok) throw new Error(`parse-docx ${res.status}`);
        return res.json();
    },

    async checkSession(code: string): Promise<boolean> {
        try {
            const res = await fetch(`${API_BASE_URL}/active/check/${code}`);
            return res.ok;
        } catch {
            return false;
        }
    },

    // WebSocket Methods
    connectHost(code: string, onUpdate: (state: InteractiveSessionState) => void): WebSocket {
        const ws = new WebSocket(`${WS_BASE_URL}/active/ws/host/${code}`);

        ws.onmessage = (event) => {
            const msg = JSON.parse(event.data);
            if (msg.type === 'SESSION_UPDATE') {
                onUpdate(msg.payload);
            }
        };

        return ws;
    },

    connectStudent(code: string, name: string, onQuestion: (question: any) => void, onLocked?: () => void): WebSocket {
        const ws = new WebSocket(`${WS_BASE_URL}/active/ws/student/${code}/${encodeURIComponent(name)}`);

        ws.onmessage = (event) => {
            const msg = JSON.parse(event.data);
            if (msg.type === 'NEW_QUESTION') {
                onQuestion(msg.payload);
            } else if (msg.type === 'WAITING') {
                onQuestion(null); // Clear active question
            } else if (msg.type === 'LOCKED') {
                onLocked?.();
            }
        };

        return ws;
    }
};
